import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const MdlSelectMultipleStaff = ({ actionClose, actionHandleSelected }) => {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(false);
  const [show, setShow] = useState(true);

  const [StaffList, setStaffList] = useState([]);
  const [mSelectedStaff, setSelectedStaff] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    localStorage.setItem("SelectedMultipleStaff", JSON.stringify([]));
    getStaffList();
  }, []);

  const getStaffList = () => {
    setLoadingStaff(true);
    setStaffList([]);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getStaff.php?";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStaff(false);
        if (response.api_status === "OK") {
          setStaffList(response.staff);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStaff(false);
        console.error("Error fetching staff:", error);
      });
  };

  const handleStaffSelection = (e, index) => {
    const isChecked = e.target.checked;
    const staff = StaffList[index];
    let updatedSelectedStaffs = [...mSelectedStaff];

    if (isChecked) {
      updatedSelectedStaffs.push(staff);
    } else {
      updatedSelectedStaffs = updatedSelectedStaffs.filter(
        (s) => s.staff_id !== staff.staff_id
      );
    }

    setSelectedStaff(updatedSelectedStaffs);
    localStorage.setItem(
      "SelectedMultipleStaff",
      JSON.stringify(updatedSelectedStaffs)
    );
  };
  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedStaff(StaffList);
      localStorage.setItem("SelectedMultipleStaff", JSON.stringify(StaffList));
    } else {
      setSelectedStaff([]);
      localStorage.setItem("SelectedMultipleStaff", JSON.stringify([]));
    }
    setSelectAll(!selectAll);
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <Modal
        show={show}
        onHide={actionClose}
        animation={false}
        className="fullscreen-modal hide-scrollbar"
        dialogClassName="fullscreen-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Select Staff Members</Modal.Title>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <Button
              className="margin_0 gravity_center"
              variant="outline-secondary"
              onClick={actionClose}
              style={{ fontSize: "2rem", height: "30px" }}
              title="Close"
            >
              &times;
            </Button>
            <Button
              className="margin_0"
              variant="primary"
              size="sm"
              onClick={() => actionHandleSelected(mSelectedStaff)}
              disabled={mSelectedStaff.length === 0}
              style={{ fontSize: "1rem", height: "30px" }}
            >
              Done ({mSelectedStaff.length})
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body className="hide-scrollbar">
          {loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-md-12 padding_0">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div className="gravity_center">
                  <h3 className="text-primary mb-0">
                    Selected Staff: {mSelectedStaff.length}
                  </h3>
                </div>
                <Button
                  className="margin_0"
                  variant={selectAll ? "outline-danger" : "outline-primary"}
                  size="sm"
                  onClick={handleSelectAll}
                  style={{ fontSize: "1rem", height: "30px" }}
                >
                  {selectAll ? "Deselect All" : "Select All"}
                </Button>
              </div>
              
              <div className="row bg_card_primary_outline" style={{ margin: "2px 10px", padding: "5px" }}>
                {loadingStaff ? (
                  <div className="col-12 text-center">
                    <MyLoader />
                  </div>
                ) : (
                  StaffList.map((item, index) => (
                    <div key={index} className="col-md-6 col-lg-4 padding_0">
                      <div
                        className={
                          mSelectedStaff.some((s) => s.staff_id === item.staff_id)
                            ? "bg_card_green_outline margin_5 padding_5"
                            : "bg_card_grey_outline margin_5 padding_5"
                        }
                        style={{ 
                          cursor: "pointer",
                          borderRadius: "10px",
                          transition: "all 0.3s ease",
                          minHeight: "90px"
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleStaffSelection({ target: { checked: !mSelectedStaff.some((s) => s.staff_id === item.staff_id) } }, index);
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <div
                              className="circular_image"
                              style={{
                                width: "70px",
                                height: "70px",
                                borderRadius: "50%",
                                overflow: "hidden"
                              }}
                            >
                              <img 
                                src={item.staff_image_path} 
                                alt="" 
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              />
                            </div>
                          </div>
                          <div className="flex-grow-1">
                            <h5 className="mb-1 fw-bold">{item.staff_name}</h5>
                            <p className="mb-1 text-muted ">
                              <strong>Department:</strong> {item.department_name}
                            </p>
                            <p className="mb-0 text-muted ">
                              <strong>Role:</strong> {item.staff_role}
                            </p>
                          </div>
                          <div className="ms-2">
                            <div
                              style={{
                                background: mSelectedStaff.some((s) => s.staff_id === item.staff_id) ? "#28a745" : "#fff",
                                color: mSelectedStaff.some((s) => s.staff_id === item.staff_id) ? "#fff" : "#000",
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "18px",
                                border: "2px solid #ddd"
                              }}
                            >
                              {mSelectedStaff.some((s) => s.staff_id === item.staff_id) ? "✓" : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlSelectMultipleStaff;
